import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import style from './style.scss'; //NOSONAR


const InputPhone = (props) => {
    const [phoneMask, setPhoneMask] = useState('');
    const [phone, setPhone] = useState(props.phone);
    const [phoneIsValid, setPhoneIsValid] = useState(false);
    const callback = props.callback ? props.callback : () => {};
    const callbackisValid = props.callbackisValid ? props.callbackisValid : () => {};

    useEffect(() => {
        let oldPhone = props.phone;

        if (oldPhone && oldPhone.indexOf('+56') === 0) {
            oldPhone = oldPhone.replace('+56', '');
        }
        _onChangePhone(oldPhone ? oldPhone : '');
    }, [props.phone]);

    useEffect(() => {
        if (props && props.defaultPhone) {
            setPhoneIsValid(validateNumber(props.defaultPhone));
            callbackisValid(validateNumber(props.defaultPhone), props.defaultPhone);
        } else {
            setPhoneIsValid(false);
        }
    }, [props.defaultPhone]);

    const onKeyPressInput = (val, ev) => {
        let number = null;

        if (!(/^[0-9]/.test(val))) {
            number = phoneMask.replace(val, '');
            setPhoneMask(number);
            validateNumber(number)
        }
        ev.preventDefault();
    }

    const validateNumber = (number) => {

        let numberMask = number.replace(/ /g, '');


        let valid = (!/[0]{9}|[1]{9}|[2]{9}|[3]{9}|[4]{9}|[9]{9}|[6]{9}|[7]{9}|[8]{9}|[9]{9}/.test(numberMask));

        if ((numberMask.length === 9) && (valid)) {
            callbackisValid(true)

            if (phone) {
                setPhone(numberMask);
            }
            callback(numberMask);

        } else {
            callbackisValid(false);
        }
        return number;
    }

    const _onChangePhone = (value) => {

        let number = value;

        number = number ? number.replace(/ /g, '') : '';
        let newChar = number[number.length - 1];

        if (!(/^[0-9]/.test(newChar))) {
            number = number.slice(0, number.length - 1);
        }

        if ((number.length) && (number.length < 10 && number.length > 3)) {
            number = number.slice(0, 1) + ' ' + number.slice(1);
        }
        validateNumber(number);
        setPhoneMask(number);
    }

    const _pasteEvent = (e) => {
        e.preventDefault();
        return null;
    }
    const { name } = props;

    return (
        <>
            <div className={"input-phone-wrap-phone " + (props.canBeDisabled && phoneIsValid ? ' disabled ' : '')}>
                <span className={"input-phone-cod-country input-default" + (props.canBeDisabled && phoneIsValid ? ' disabled ' : '')}>+56</span>
                <input
                    type="tel"
                    className={'input-phone-number input-default' + (props.canBeDisabled && phoneIsValid ? ' disabled ' : '')}
                    name={name ? name : ''}
                    onPaste={_pasteEvent}
                    maxLength="10"
                    placeholder={props.placeholder ? props.placeholder : '9 24871274'}
                    value={phoneMask}
                    onChange={(ev) => _onChangePhone(ev.target.value)}
                    onBlur={(ev) => _onChangePhone(ev.target.value)}
                    onKeyUp={(val) => onKeyPressInput(val.key, val)}
                    disabled={props.canBeDisabled && phoneIsValid ? true : false}
                />
            </div>
        </>
    )
};

InputPhone.propTypes = {
    phone: PropTypes.string,
    callback: PropTypes.func,
    callbackisValid: PropTypes.func,
    name: PropTypes.string,
    defaultPhone: PropTypes.string,
    canBeDisabled: PropTypes.bool
};

export default InputPhone;
